var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    zoomAndPan: "magnify",
    viewBox: "0 0 60 37.5",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7cb69b9ec4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 1.308594 L 53.546875 1.308594 L 53.546875 35.355469 L 37 35.355469 Z M 37 1.308594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1ce46c79e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.175781 1.308594 L 22 1.308594 L 22 35.355469 L 6.175781 35.355469 Z M 6.175781 1.308594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "320d23c8ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 1.308594 L 38 1.308594 L 38 35.355469 L 21 35.355469 Z M 21 1.308594 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7cb69b9ec4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M 53.53125 30.117188 C 53.53125 33.007812 51.175781 35.355469 48.269531 35.355469 L 37.75 35.355469 L 37.75 1.308594 L 48.269531 1.308594 C 51.175781 1.308594 53.53125 3.652344 53.53125 6.546875 Z M 53.53125 30.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e1ce46c79e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002495",
    d: "M 11.453125 1.308594 C 8.546875 1.308594 6.191406 3.652344 6.191406 6.546875 L 6.191406 30.117188 C 6.191406 33.007812 8.546875 35.355469 11.453125 35.355469 L 21.972656 35.355469 L 21.972656 1.308594 Z M 11.453125 1.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#320d23c8ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eeeeee",
    d: "M 21.972656 1.308594 L 37.75 1.308594 L 37.75 35.355469 L 21.972656 35.355469 Z M 21.972656 1.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.8636e1e9a3cfaf7b0fa67834c2c961d5.svg";
export { ForwardRef as ReactComponent };